import React from 'react';

export default function MailIcon(): JSX.Element {
  return (
    <svg
      width="81"
      height="82"
      viewBox="0 0 81 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="40.5" cy="40.6904" r="40.5" fill="#0047D4" />
      <path
        d="M26 29.25C25.2969 29.25 24.75 29.875 24.75 30.5V32.2969L38.1875 43.3125C39.8281 44.6406 42.0938 44.6406 43.7344 43.3125L57.25 32.2969V30.5C57.25 29.875 56.625 29.25 56 29.25H26ZM24.75 37.1406V50.5C24.75 51.2031 25.2969 51.75 26 51.75H56C56.625 51.75 57.25 51.2031 57.25 50.5V37.1406L46.1562 46.2031C43.1094 48.7031 38.8125 48.7031 35.8438 46.2031L24.75 37.1406ZM21 30.5C21 27.7656 23.1875 25.5 26 25.5H56C58.7344 25.5 61 27.7656 61 30.5V50.5C61 53.3125 58.7344 55.5 56 55.5H26C23.1875 55.5 21 53.3125 21 50.5V30.5Z"
        fill="white"
      />
    </svg>
  );
}
